<template>
  <div class="appointment_box">
    <h2 class="appointment_box--heading">Appointments</h2>

    <app-loading-section :loading="loadingCalendar" class="appointment_box--body">
      <div class="flex flex-centered">
        <user-dashboard-calendar
          :date="selectedDate"
          :appointments="appointmentsCalendar"
          @changed="updateCalendar"
          @input="updateSelectedDate"
        />
      </div>

      <date-selector
        class="mt-100"
        v-model="selectedDate"
        @input="updateSelectedDate"
      />

      <app-loading-section :loading="loadingToday">
        <user-dashboard-appointment-item
          v-for="appointment in appointmentsToday"
          :key="appointment.id"
          :appointment="appointment"
        />
      </app-loading-section>
    </app-loading-section>
  </div>
</template>

<script>
import dates from "../../../services/dates";
import DateSelector from "./DateSelector";
import UserDashboardAppointmentItem from "./UserDashboardAppointmentItem";
import UserDashboardCalendar from "./UserDashboardCalendar";

export default {
  name: "UserDashboardAppointmentsBox",
  components: {UserDashboardCalendar, UserDashboardAppointmentItem, DateSelector},
  data() {
    return {
      loadingToday: true,
      loadingCalendar: true,
      selectedDate: dates.getTodayISO(),
    }
  },
  mounted() {
    this.getAppointmentsCalendar()
    this.getAppointmentsToday()
  },
  destroyed() {
    this.$store.dispatch("dashboardAppointments/tearDown");
  },
  computed: {
    appointmentsCalendar() {
      const appointments = this.$store.getters["dashboardAppointments/calendarList"]

      if (appointments.length === 0) return []

      return appointments
    },
    appointmentsToday() {
      return this.$store.getters["dashboardAppointments/todayList"]
    }
  },
  methods: {
    getAppointmentsCalendar(value = null) {
      const datetime = (value !== null) ? value : this.selectedDate
      this.$store.dispatch("dashboardAppointments/setupCalendarList", datetime).then(() => {
        this.loadingCalendar = false
      })
    },
    getAppointmentsToday() {
      this.loadingToday = true
      this.$store.dispatch("dashboardAppointments/setupTodayList", this.selectedDate).then(() => {
        this.loadingToday = false
      })
    },
    updateCalendar(value) {
      this.getAppointmentsCalendar(value)
    },
    updateSelectedDate(value) {
      this.selectedDate = value
      this.getAppointmentsToday()
    }
  },
}
</script>

<style lang="scss" scoped>
.appointment_box {
  display: flex;
  flex-direction: column;
  height: 100%;

  &--heading {
    padding: 14px 14px 0;
    font-weight: bold;
  }

  &--body {
    flex-grow: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
